<template>
  <BaseStatusBar :icon="currentIcon">
    <template v-slot:first_tab v-if="reserve.status == 'confirmed'">
      <h3>{{ accept_time }} {{ $t("waiting.time") }}</h3>
      <p>
        {{
          true
            ? $t("preorder_status_bar.accept_desc")
            : $t("preorder_status_bar.accept_local")
        }}
      </p>
    </template>
  </BaseStatusBar>
</template>

<script>
import BaseStatusBar from "@/components/statusbar/BaseStatusBar.vue";

import moment from "moment";

export default {
  props: {
    reserve: Object,
  },
  data() {
    return {
      accept_time: 0,

      accept_timer_id: 0
    };
  },
  methods: {
    tickAcceptTime() {
      this.accept_time = moment(
        this.reserve.confirmed_at || this.reserve.created_at
      ).add(15, 'minutes').diff(
        moment(),
        'minutes'
      );
    }
  },
  mounted() {
    this.tickAcceptTime();

    this.accept_timer_id = setInterval(this.tickAcceptTime, 30 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.accept_timer_id);
  },
  computed: {
    currentIcon() {
      return "/icons/warning.svg";
    },
  },
  components: {
    BaseStatusBar,
  },
};
</script>

<style scoped>
.status-paid {
  color: #129b81 !important;
}

.status-unpaid {
  color: #e2223b !important;
}
</style>
